// Create a map of the form { id1: true, id2: true, ... }
export const itemTransform = (selected, all) =>
  selected
    .filter((id) => all.find((x) => x.id === id))
    .reduce((acc, id) => ({ [id]: true, ...acc }), {});

// Returns the alphabetically first label (or corresponding id) of the selected items
export const findFirst = (selectedItems, all, returnType, placeholder = "") => {
  if (!selectedItems.length) return placeholder;
  const filtered = all.filter((x) => selectedItems.includes(x.id));
  const sorted = filtered.sort((a, b) => a.label.localeCompare(b.label));
  return sorted[0]?.[returnType] || "";
};
